<template>
  <div class="tool-list">
    <!-- Empty state -->
    <div v-if="tools.length === 0" class="empty-state">
      <p class="text-gray-500 dark:text-gray-400 text-center py-8">
        No tools available. Connect to an MCP server to see available tools.
      </p>
    </div>

    <!-- Tool list -->
    <div v-else class="space-y-2">
      <div v-for="tool in tools" :key="tool.id" class="relative">
        <button
          type="button"
          class="w-full text-left transition-all duration-200 rounded-lg border p-4 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          :class="[
            selectedToolId === tool.id
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 ring-1 ring-blue-500'
              : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-750',
          ]"
          @click="selectTool(tool.id)"
        >
          <h3 class="font-semibold text-gray-900 dark:text-gray-100 mb-1">
            {{ tool.name }}
          </h3>
          <p class="text-sm text-gray-600 dark:text-gray-400 line-clamp-2">
            {{ tool.description }}
          </p>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { McpTool } from '../../types';

  interface Props {
    tools: McpTool[];
    selectedToolId?: string | null;
  }

  interface Emits {
    (e: 'select', toolId: string): void;
  }

  defineProps<Props>();
  const emit = defineEmits<Emits>();

  const selectTool = (toolId: string) => {
    console.log('ToolList: Emitting select for tool:', toolId);
    emit('select', toolId);
  };
</script>

<style scoped>
  .tool-list {
    @apply w-full;
  }

  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>
